var map = {
	"./close-eye.svg": 37482,
	"./close.svg": 36802,
	"./confirm.svg": 48558,
	"./delete.svg": 75999,
	"./download.svg": 70118,
	"./edits.svg": 22733,
	"./eye.svg": 60281,
	"./logo.svg": 96615,
	"./menu-down.svg": 24444,
	"./menu-up.svg": 32183,
	"./password.svg": 15717,
	"./pdf.svg": 280,
	"./phone.svg": 30902,
	"./right.svg": 85352,
	"./search.svg": 40590,
	"./upload.svg": 85373,
	"./user.svg": 16503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24078;